<template>
  <a :href="link" v-analytics="{label:'special_icon_click'}" class="global-navi-beautyday-button-term4">アットコスメビューティーデー本日最終日</a>
</template>

<script>
import Config    from '../../../libs/config';
import analytics from '../../../directives/analytics';

export default {
  name      : 'beautyday-button-term4',
  directives: {
    analytics,
  },
  data: function() {
    return {
      link: Config.BEAUTYDAY_URL,
    };
  },
};
</script>
